/**
 * Утилиты для создания HTML элементов подсказок координат
 */

import { formatCoordinates } from './parseCoordinates';
import {
    COORDINATE_SEARCH_MESSAGES,
    COORDINATE_SEARCH_ICONS,
    generateSearchHintStyles,
    generatePinnedHintStyles,
    generateCoordinatesTextStyles,
    generateActionTextStyles,
    generateActionContainerStyles,
} from './coordinateSearchConfig';

/**
 * Создать элемент поиск подсказки (динамической)
 * @param {Object} coords - {lat, lng}
 * @returns {HTMLElement}
 */
export const createSearchHintElement = coords => {
    const hint = document.createElement('div');
    hint.className = 'coordinate-search-hint';
    hint.dataset.lat = coords.lat;
    hint.dataset.lng = coords.lng;
    hint.dataset.state = 'search';

    const formatted = formatCoordinates(coords);

    hint.innerHTML = `
        <div style="${generateSearchHintStyles()}">
            <div style="${generateCoordinatesTextStyles()}">${formatted}</div>
            <div style="${generateActionContainerStyles()}">
                <div style="${generateActionTextStyles()}">${COORDINATE_SEARCH_MESSAGES.NAVIGATE}</div>
                ${COORDINATE_SEARCH_ICONS.ARROW}
            </div>
        </div>
    `;

    return hint;
};

/**
 * Создать элемент закреплённой подсказки (плашки)
 * @param {Object} coords - {lat, lng}
 * @param {string} markerId - id маркера
 * @param {number} markerNumber - номер маркера
 * @returns {HTMLElement}
 */
export const createPinnedHintElement = (coords, markerId, markerNumber) => {
    const hint = document.createElement('div');
    hint.className = 'coordinate-search-hint';
    hint.dataset.lat = coords.lat;
    hint.dataset.lng = coords.lng;
    hint.dataset.state = 'pinned';
    hint.dataset.markerId = markerId;

    const formatted = formatCoordinates(coords);

    hint.innerHTML = `
        <div style="${generatePinnedHintStyles()}">
            <div style="${generateCoordinatesTextStyles()}">${formatted}</div>
            <div style="${generateActionContainerStyles()}">
                <div style="${generateActionTextStyles()}">${COORDINATE_SEARCH_MESSAGES.POINT_PREFIX} ${markerNumber}</div>
                ${COORDINATE_SEARCH_ICONS.DELETE}
            </div>
        </div>
    `;

    return hint;
};

/**
 * Создать контейнер для подсказок поиска если его нет
 * @returns {HTMLElement}
 */
export const getOrCreateSearchHintsWrapper = () => {
    let searchHintsWrapper = document.querySelector('.coordinate-search-hints');

    if (!searchHintsWrapper) {
        searchHintsWrapper = document.createElement('div');
        searchHintsWrapper.className = 'coordinate-search-hints';
        searchHintsWrapper.style.cssText = `
            position: relative;
            width: 100%;
        `;
    }

    return searchHintsWrapper;
};
